import React, { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
// material
import { styled } from '@mui/material/styles';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import useResponsive from '../../componentes/useResponsive';
import { getUniqueKey, showLoader, workWithLocalStorage } from '../../auxiliares/funciones';

import Citas from '../../paginas/agenda/citas';
import LectorCupones from '../../paginas/cupones/lector';
import { useCentro } from '../../contextos/CentroContext';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  width: '100%',
  maxWidth: '100%'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  minWidth: 0,
  maxWidth: '100%',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  paddingBottom: theme.spacing(2),
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

function TabPanel(props) {
  // eslint-disable-next-line react/prop-types
  const { children, value, index } = props;
  const visible = value !== index ? 'none' : 'block';

  return (
    <Box sx={{ display: visible, width: '100%', minWidth: 0, maxWidth: '100%' }} id={`tabpanel-${index}`}>
      <Box
        component="div"
        sx={{
          p: { xs: 1, sm: 2, md: 3 },
          overflowY: 'auto',
          maxHeight: props.APP_HEADER,
          overflowX: 'auto',
          maxWidth: '100%',
          width: '100%',
          minWidth: 0
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

function showTab(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const getInitialTab = () => {
  const user = workWithLocalStorage('get', 'usuario', null);
  const userPerfil = user ? Number(user.idPerfil || user.perfil || 1) : 1;
  if (userPerfil === 2) {
    return [{ nombre: 'Lector Cupones', componente: LectorCupones, params: {}, visible: true, index: 0 }];
  }
  return [{ nombre: 'Agenda', componente: Citas, params: {}, visible: true, index: 0 }];
};

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { centro } = useCentro();
  const isDesktop = useResponsive('up', 'lg');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(true);

  const [value, setValue] = useState(0);
  const [tabs, addTabs] = useState(getInitialTab);
  const [APP_HEADER, setAppHeader] = useState(window.innerHeight - (49 + 92) - 25);
  const [CONTENT_WIDTH, setContentWidth] = useState(window.innerWidth - (desktopOpen ? 311 : 32));
  const loader = true;

  React.useEffect(() => {
    if (typeof document !== 'undefined' && centro && centro.nombre) {
      const activeTabName = tabs[value]?.nombre || 'Agenda';
      document.title = `${activeTabName} | ${centro.nombre}`;
    }
  }, [value, tabs, centro]);

  React.useEffect(() => {
    const handleResize = () => {
      setAppHeader(window.innerHeight - (49 + 92) - 25);
      setContentWidth(window.innerWidth - (desktopOpen ? 311 : 32));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [desktopOpen]);

  const handleToggleSidebar = () => {
    if (isDesktop) {
      setDesktopOpen(!desktopOpen);
    } else {
      setMobileOpen(!mobileOpen);
    }
  };

  const setLoader = (mostrar) => {
    showLoader(mostrar);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const setTabs = (item) => {
    const index = tabs.findIndex((e) => e.nombre === item.nombre);
    if (index < 0) {
      setLoader(true);
      item.index = getUniqueKey();
      addTabs(tabs.concat([item]));
      setValue(tabs.length);
    } else {
      setValue(index);
      showTab(index);
    }
  };

  const closeTab = (e, index) => {
    setLoader(true);
    tabs.splice(index, 1);
    addTabs(tabs);
    setValue(index - 1);
    setLoader(false);
  };

  return (
    <RootStyle>
      <Backdrop id="loader" sx={{ color: '#103996', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DashboardNavbar onToggleSidebar={handleToggleSidebar} isDesktopSidebarOpen={desktopOpen} />
      <DashboardSidebar
        setTabs={setTabs}
        isOpenSidebar={mobileOpen}
        isDesktopSidebarOpen={desktopOpen}
        onCloseSidebar={() => setMobileOpen(false)}
      />
      <MainStyle>
            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} scrollButtons allowScrollButtonsMobile variant="scrollable">
                {
                  // eslint-disable-next-line no-unused-expressions, array-callback-return
                  tabs.map((t,index) => <Tab sx={{ display: 'block' }} key={`${t.index}`} {...showTab(index)} label={
                      <>
                        <span>{t.nombre}{' '}</span>
                        <CloseIcon fontSize="inherit" onClick={(e) => closeTab(e,index) }/>
                      </>} />)
                }
                </Tabs>
              </Box>          
                {
                  // eslint-disable-next-line no-unused-expressions, array-callback-return
                  tabs.map((t,index) => <TabPanel key={`${t.index}`} value={value} index={index} APP_HEADER={APP_HEADER} CONTENT_WIDTH={CONTENT_WIDTH}>
                      <t.componente key={t.index} index={index} showLoader={setLoader} setTabs={setTabs} params={t.params} />
                    </TabPanel>)
                }
            </Box>
          </MainStyle>
        </RootStyle>
      );
}
